"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const FormattedText = ({ children, boldNumbers = false, }) => {
    // Helper function to process a text segment for numbers.
    const processForNumbers = (text) => {
        // Split by any sequence of digits. The capturing parentheses ensure that the numbers
        // are included in the result array.
        const parts = text.split(/(\d+)/);
        return parts.map((part, idx) => {
            // Check if the part is a number. Note that this regex matches one or more digits.
            if (/^\d+$/.test(part)) {
                return (0, jsx_runtime_1.jsx)("b", { children: part }, idx);
            }
            return part;
        });
    };
    // First, split the entire text by the explicit bold markers "**"
    const explicitBoldParts = children.split('**');
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: explicitBoldParts.map((part, index) => {
            // For the parts that were wrapped in ** markers (odd indexes), we know they are bold.
            if (index % 2 !== 0) {
                return (0, jsx_runtime_1.jsx)("b", { children: part }, index);
            }
            // For non-bold text, process further if boldNumbers is true.
            if (boldNumbers) {
                return ((0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: processForNumbers(part) }, index));
            }
            return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, { children: part }, index);
        }) }));
};
exports.FormattedText = FormattedText;
